import { formatValue } from '../../glossary/formatValue';
import { FormatKind } from './types';

export function isEmpty(v: unknown): boolean {
  return (
    v === null ||
    v === undefined ||
    v === '' ||
    (Array.isArray(v) && v.length === 0) ||
    (typeof v === 'object' && !Array.isArray(v) && Object.keys(v as object).length === 0)
  );
}

function formatDate(ms: unknown): string {
  if (typeof ms !== 'number' || !Number.isFinite(ms)) return '—';
  const d = new Date(ms);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
}

export function formatField(value: unknown, format: FormatKind): string {
  if (format === 'date') return formatDate(value);
  return formatValue(value, format);
}

/**
 * Best-effort format inference for fields without an explicit `format`.
 * Used by the raw-dump fallback where keys come straight off
 * `PolicyFundingSource` without curation. Suffix-based heuristics are
 * tuned to the field-naming conventions in `FundingSources.d.ts`.
 */
export function inferFormat(value: unknown, key?: string): FormatKind {
  if (typeof value === 'boolean') return 'boolean';
  if (typeof value === 'number' && key) {
    const k = key.toLowerCase();
    if (k.includes('rate') || k.endsWith('percent') || k.includes('protection')) {
      if (Math.abs(value) < 1) return 'percent';
      return 'integer';
    }
    if (k.endsWith('years')) return 'years';
    if (k.endsWith('months')) return 'months';
    if (k.endsWith('days')) return 'days';
    if (
      k.includes('amount') ||
      k.includes('cost') ||
      k.includes('benefit') ||
      k.includes('payout') ||
      k.includes('premium') ||
      k.includes('value') ||
      k.endsWith('payment') ||
      k.includes('surplus') ||
      k.endsWith('pool')
    ) {
      return 'currency';
    }
    return 'integer';
  }
  if (typeof value === 'number') return 'integer';
  return 'text';
}

